/**
 * @flow
 * @relayHash afa3b880be7da7d3b5763484c63c4c2a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getInviteEmailQueryVariables = {|
  id: string
|};
export type getInviteEmailQueryResponse = {|
  +hyevent: {|
    +inviteEmailHtml: ?string,
    +confirmPageHtml: ?string,
    +confirmEmailHtml: ?string,
    +thankYouPageHtml: ?string,
  |}
|};
export type getInviteEmailQuery = {|
  variables: getInviteEmailQueryVariables,
  response: getInviteEmailQueryResponse,
|};
*/


/*
query getInviteEmailQuery(
  $id: ID!
) {
  hyevent(id: $id) {
    inviteEmailHtml
    confirmPageHtml
    confirmEmailHtml
    thankYouPageHtml
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inviteEmailHtml",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "confirmPageHtml",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "confirmEmailHtml",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "thankYouPageHtml",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getInviteEmailQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "getInviteEmailQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "getInviteEmailQuery",
    "id": null,
    "text": "query getInviteEmailQuery(\n  $id: ID!\n) {\n  hyevent(id: $id) {\n    inviteEmailHtml\n    confirmPageHtml\n    confirmEmailHtml\n    thankYouPageHtml\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '27624667297816d04b1bdb0144c24bb7';
module.exports = node;
